module.exports = __webpack_public_path__ + "img/tz.f1eb7333.svg";